import { render, staticRenderFns } from "./blocks_detail.vue?vue&type=template&id=b984140a&"
import script from "./blocks_detail.vue?vue&type=script&lang=js&"
export * from "./blocks_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports